<div class="col-sm-2 incident-reports-filter">
    <div class="incident-reports-filter_view-part" (click)="showDropdown = !showDropdown">Filter</div>
    <div class="incident-reports-filter_dropdown" [hidden]="!showDropdown">
        <div class="m-b-xs filter-checkbox directory-add-modal-date-field">
            <label>Start Date</label>
            <mat-form-field (click)="startPicker.open()">
                <input matInput [(ngModel)]="startDate" name="startDate" [matDatepicker]="startPicker" disabled
                       (focus)="startPicker.open()" (click)="startPicker.open()"
                       (ngModelChange)="onStartDateChange()" placeholder="Choose a date">
                <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                <mat-datepicker #startPicker disabled="false"></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="m-b-xs filter-checkbox directory-add-modal-date-field">
            <label>End Date</label>
            <mat-form-field (click)="endPicker.open()">
                <input matInput [(ngModel)]="endDate" name="endDate" disabled
                       [matDatepicker]="endPicker" [min]="startDate"
                       (focus)="endPicker.open()" (click)="endPicker.open()" placeholder="Choose a date">
                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker disabled="false"></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="row text-center buttons-row">
            <button class="btn btn-primary" [disabled]="!startDate && !endDate" (click)="changeFilter(null)">
                Apply
            </button>

            <button class="btn btn-primary" *ngIf="startDate || endDate" (click)="clearDates()">
                Clear
            </button>
        </div>

        <hr>

        <div class="incident-reports-filter_list">
            <div class="m-b-xs filter-checkbox" *ngFor="let incidentType of incidentTypes">
                <label class="img-checkbox">
                    <input type="checkbox" [checked]="filterCheckBoxChecked(incidentType.id)"
                        id="{{incidentType.name}}" #{{incidentType.name}}
                        (change)="changeFilter(incidentType.id)">
                    <label for="{{incidentType.name}}"><svg-checked></svg-checked></label>
                    <span>{{incidentType.name}}</span>
                </label>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/incident-reports-filter/incident-reports-filter.component.html